export default __webpack_public_path__ + "static/media/img-0535-slovakia-full-face.505a6d41.png";